import { Button, Card, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { errorMsg, formItemLayout } from "../../../const/constant";
import { history, label } from "../../../framework";
import {
  authenticateAction,
  dataWrapper,
  loginAction,
  routeToPageNotFoundAction,
} from "../../../redux/actions";
import OtpModal from "../OTPModal";
//import * as ewcms from '../EWCMS/styleMaster';
import "./PTPSAuth.less";

function PTPSAuth(props) {
  const { login, dataFetch, doAuthenticate, device } = props;
  const imgPath = process.env.PUBLIC_URL + "/assets/img/";

  const [form] = Form.useForm();

  const [tabKey, setTabKey] = useState<"name" | "netid">("name");
  //Store email
  const [email, setEmail] = useState("");
  //Set new form

  const onTabChange = (key) => {
    setTabKey(key);
  };
  const [showModal, setshowModal] = useState(false);
  //Otp state
  const [otpInfo, setOtpInfo] = useState({ otpLogin: false });
  //const polyuColor = ewcms.polyuRed;
  const tabList = [
    {
      key: "name",
      tab: "Name and HKID",
    },
    {
      key: "netid",
      tab: "NetID and Password",
    },
  ];

  const onFormFinish = async (values: any) => {
    //message.success("Submit Success!");
    //
    const result = {
      loginType: tabKey,
      formData: values,
    };
    const staffRes = await login(result);
    if (staffRes?.value?.staffNo) {
      doAuthenticate();
      const emailRes = await dataFetch("ptps/getEmailAddress", {}, "GET");
      if (emailRes?.value?.email && emailRes?.value?.email !== "") {
        //Set email only when form inputs are different
        setEmail(emailRes.value.email);
        setshowModal(true);
      } else {
        setEmail("");
        errorMsg("User Email Not Found, Please contact HRO");
      }
    }
  };

  const onADFSSignIn = () => {
    if (process.env.REACT_APP_PTPS_ADFS_LOGIN_URL) {
      window.location.href = process.env.REACT_APP_PTPS_ADFS_LOGIN_URL;
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  useEffect(() => {
    if (otpInfo.otpLogin) {
      history.push("/ptps");
    }
  }, [otpInfo]);

  const AuthFormNetId = () => {
    return (
      <Button type="primary" htmlType="submit" onClick={onADFSSignIn}>
        ADFS Sign In
      </Button>
    );
  };
  const AuthFormName = () => {
    return (
      <Form
        name="basic"
        form={form}
        {...formItemLayout[device.size]}
        layout={device.size === "desktop" ? "horizontal" : "vertical"}
        initialValues={{ remember: true }}
        onFinish={onFormFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item
          label="Name"
          name="name"
          key="name"
          rules={[
            {
              required: true,
              message: label("EC0005").replace("{%1}", "Name"),
            },
          ]}
        >
          <Input placeholder="Family Name + First Name" />
        </Form.Item>
        <Form.Item
          label="HKID / Passport"
          name="hkid"
          key="hkid"
          rules={[
            {
              required: true,
              message: label("EC0005").replace("{%1}", "HKID / Passport"),
            },
            {
              len: 6,
              message: label("EC0014")
                .replace("{%1}", "6")
                .replace("{%2}", "HKID / Passport"),
            },
          ]}
        >
          <Input placeholder="First 6 character of HKID/Passport" />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }} key="submit">
          <Button type="primary" htmlType="submit">
            Sign in
          </Button>
        </Form.Item>
      </Form>
    );
  };

  const contentList: Record<string, React.ReactNode> = {
    netid: AuthFormNetId(),
    name: AuthFormName(),
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <OtpModal
        title={"One-Time Password Verification"}
        showModal={showModal}
        setshowModal={setshowModal}
        setOtpInfo={setOtpInfo}
        email={email}
      />
      <div className="mobile-menu-wrap innerFlex">
        <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
          <img
            style={{ objectFit: "scale-down" }}
            src={imgPath + "main-logo-1x.png"}
            alt=""
            srcSet={
              imgPath +
              "main-logo-1x.png 1x," +
              imgPath +
              "main-logo-2x.png 2x," +
              imgPath +
              "main-logo-3x.png 3x"
            }
          />
          <h1 className="ptpsheader">Part-time Payment System</h1>
        </div>
        <Card
          tabList={tabList}
          activeTabKey={tabKey}
          onTabChange={onTabChange}
          className="card"
        >
          {contentList[tabKey]}
        </Card>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    device: state.session.device,
    otpInfo: state.session.otpInfo,
    staffNo: state.session.staffNo,
  };
};

const mapDispatchToProps = (dispatch) => ({
  login: (value) => {
    return dispatch(loginAction(value));
  },
  pageNotFound: () => {
    dispatch(routeToPageNotFoundAction());
  },
  dataFetch: (apiPath, data, method) => {
    const res = dispatch(dataWrapper(apiPath, data, method));
    return res;
  },
  doAuthenticate: () => {
    dispatch(authenticateAction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PTPSAuth);
